const AppPagesID = {
    TeamAttenadance: 'ap00000804u8m3u7n0ail',
    TeamTimesheet: 'ap00000817jhogoz13vso',
    TeamAttendanceCorrections: 'ap0000082imw46ouzehqz',
    TeamTimeOff: 'ap0000080roy4wtvoz2vn',
    TeamOvertime: 'ap0000080j2exbzerkueb',
    TeamCalendar: 'ap00000830zdjzdcrxdi0',
    TeamWorkshiftPlan: 'ap000008204gel6fh59z9',
    TeamProjectCharges: 'ap0000080ycu3yehaman8',
    UploadAttendance: 'ap0000083eo7hc0qqfbby'
}

export default AppPagesID